import { Link } from 'react-router-dom';
import { hotKeywords, stats } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20abstract%20illustration%20of%20lively%20university%20campus%20life%20collage%20with%20speech%20bubbles%20confetti%20and%20geometric%20shapes%2C%20warm%20coral%20orange%20and%20golden%20amber%20tones%2C%20soft%20cream%20background%2C%20editorial%20poster%20art%2C%20energetic%20youthful%20mood%2C%20clean%20minimal%20composition%2C%20no%20text&width=1600&height=900&seq=hero-campus-gossip-01&orientation=landscape"
          alt="高校吃瓜社 校园热门话题围观插画"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto w-full px-4 py-14 md:px-6 md:py-20 lg:px-10 lg:py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3.5 py-1.5 text-xs font-semibold text-background-50 md:text-sm">
            <i className="ri-live-line text-base leading-none" aria-hidden="true"></i>
            实时围观中 · 今日更新 9 起事件
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.2] text-background-50 md:text-5xl lg:text-[3.4rem]">
            高校吃瓜社
            <span className="mt-2 block text-2xl font-bold text-accent-300 md:text-4xl">
              围观校园热门现场，吃瓜不迷路
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            聚焦高校吃瓜事件与高校吃瓜热点，实时跟进校园热门现场。这里既有同学们的一手投稿见闻，也有每起事件的前因后果与时间线梳理，帮你在围观之前先看清整件事。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/events"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览事件合集
              <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
            </Link>
            <Link
              to="/#submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/50 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-send-plane-line text-base leading-none" aria-hidden="true"></i>
              我要爆料投稿
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-100/25 pt-6 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dd className="font-heading text-xl font-black text-accent-300 md:text-2xl">{item.value}</dd>
                <dt className="mt-1 text-xs text-background-200 md:text-sm">{item.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative border-t border-background-100/20 bg-foreground-950/85">
        <div className="flex items-center gap-4 overflow-hidden py-3">
          <span className="ml-4 hidden shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50 md:flex md:ml-10">
            <i className="ri-fire-fill text-sm leading-none" aria-hidden="true"></i>
            热搜
          </span>
          <div className="flex min-w-0 flex-1 overflow-hidden">
            <div className="marquee-track flex shrink-0 items-center gap-8 pr-8">
              {[...hotKeywords, ...hotKeywords].map((word, index) => (
                <Link
                  key={`${word}-${index}`}
                  to={`/events?q=${encodeURIComponent(word)}`}
                  className="whitespace-nowrap text-xs font-medium text-background-100 transition-colors hover:text-accent-300 md:text-sm"
                >
                  #{word}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}